export var formatDate = function formatDate(date) {
  var currentDate = new Date(date);
  return currentDate.toLocaleString('ru-RU', {
    month: 'numeric',
    day: 'numeric'
  });
};